import { createSelector } from "reselect";

import getDomain from "../base_getters/get_domain";
import getProjectId from "./get_project_id";
import { FloorTradeDeviationMagnitudes } from "../../reducers/domain/reduce_floor_trade_deviation_magnitudes";

const getFloorTradeDeviationMagnitudes = createSelector([
  getDomain,
  getProjectId
], (domain, projectId): FloorTradeDeviationMagnitudes => {
  return domain.floorTradeDeviationMagnitudes?.byFirebaseProjectId?.[projectId] ?? {};
});

export default getFloorTradeDeviationMagnitudes;
